/*
 * @Author: liujie09
 * @Date: 2021-07-29 14:32:10
 * @Description: some description
 * @LastEditTime: 2021-11-24 15:02:57
 * @FilePath: /kast/packages/bus/src/store.ts
 */
import { isObject, isArray, isFunction, warn, isStringSymbolUnion } from './utils';
import { setCache, getCache } from './cache';
import { IStoreHooks, StringSymbolUnion, IStoreIO, EventCallBack } from './types';

const storeNameSpace = 'store';
class Store implements IStoreIO, IStoreHooks {
  store: object;
  storeEmitter: object;

  constructor() {
    this.store = {};
    this.storeEmitter = {};
  }

  private getValue(key: StringSymbolUnion) {
    return this.store[key];
  }

  private setValue(key: StringSymbolUnion, value: any) {
    this.store[key] = value;
    this.emit(key);
  }

  private emit(key: StringSymbolUnion) {
    const keyEmitter = this.storeEmitter[key];

    if (!isArray(keyEmitter) || (isArray(keyEmitter) && keyEmitter.length === 0)) {
      return;
    }

    const value = this.getValue(key);
    keyEmitter.forEach((cb: EventCallBack) => {
      cb(value);
    });
  }

  get(key?: StringSymbolUnion) {
    if (key === undefined) {
      return this.store;
    }

    if (!isStringSymbolUnion(key)) {
      warn('store.get: key should be string / symbol');
      return null;
    }

    return this.getValue(key);
  }

  set<T>(key: string | symbol | object, value?: T) {
    if (!isStringSymbolUnion(key) && !isObject(key)) {
      warn('store.set: key should be string / symbol / object');
      return;
    }

    if (isObject(key)) {
      Object.keys(key).forEach(k => {
        const v = key[k];

        this.setValue(k, v);
      });
    } else {
      this.setValue(key as StringSymbolUnion, value);
    }
  }

  on(key: StringSymbolUnion, callback: EventCallBack, force?: boolean) {
    if (!isStringSymbolUnion(key)) {
      warn('store.on: key should be string / symbol');
      return;
    }

    if (!isFunction(callback)) {
      warn('store.on: callback is required, should be function');
      return;
    }

    if (!this.storeEmitter[key]) {
      this.storeEmitter[key] = [];
    }

    this.storeEmitter[key].push(callback);

    if (force) {
      callback(this.getValue(key));
    }
  }

  off(key: StringSymbolUnion, callback?: EventCallBack) {
    if (!isStringSymbolUnion(key)) {
      warn('store.off: key should be string / symbol');
      return;
    }

    if (!isArray(this.storeEmitter[key])) {
      warn(`store.off: ${String(key)} has no callback`);
      return;
    }

    if (callback === undefined) {
      this.storeEmitter[key] = undefined;
      return;
    }

    this.storeEmitter[key] = this.storeEmitter[key].filter((cb: EventCallBack) => cb !== callback);
  }

  has(key: StringSymbolUnion) {
    const keyEmitter = this.storeEmitter[key];
    return isArray(keyEmitter) && keyEmitter.length > 0;
  }
}

let store = getCache(storeNameSpace);
if (!store) {
  store = new Store();
  setCache(storeNameSpace, store);
}

export default store;
